import React, { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { BottomLayout } from "@/components/responsive/product/layer/bottomLayout/BottomLayout";
import { BundleGroup } from '@/components/responsive/product/layer/bundle/bundleGroup/BundleGroup';
import { RootState } from '@/models/appState/RootState';
import { BundleOffersGroup } from "@/models/scope/productSheet/promotionalOffers/BundleOffersGroup";
import { formatDate } from "@/utils/responsive/utils";

export const BundleLayer: VoidFunctionComponent<{ isMobile: boolean }> = ({ isMobile }) => {
  const bundle = useSelector((state: RootState) => state.promotionalOffers.bundleOffers);
  const isLoading = useSelector((state: RootState) => state.promotionalOffers.isLoading);

  if (!bundle) return null;

  const { endDate, component, description, discountType, discountValue, application } = bundle;
  const value = discountValue;
  const type = discountType;
  const scope = application;
  const hasOfferLabels = description && value && type && scope;
  const offerLabel = (
    <>
      {description} =
      <span className='red'>
        {' '}
        {value}
        {type} {scope}
      </span>
    </>
  );

  return (
    isLoading ? null : <div className='bundle'>
      <div className='body'>
        <p className='subtitle'>Découvrez l'offre pack</p>
        {!!description && <p className='offer-top'>{description}</p>}
        {!!endDate && (
          <p className='date'>Valable jusqu'au {formatDate(endDate)}</p>
        )}
        {component.map((groups: BundleOffersGroup, i: number) => (
          <BundleGroup
            key={i}
            group={groups}
            isMobile={isMobile}
            index={i}
            componentLength={component.length}
          />
        ))}
      </div>
      <BottomLayout>
        <div className='content'>
          {!!hasOfferLabels && <p className='offer-bottom'>{offerLabel}</p>}
          <div className='info'>
            <img src={"/assets/images/responsive/icons/info.svg"} alt='icone info' />
            <p>
              Rendez-vous sur la fiche de l’article pour l’ajouter au panier.
            </p>
          </div>
        </div>
      </BottomLayout>
    </div>
  );
};